import { useState } from 'react';
import localeService from 'src/dataServices/LocaleService';
import './TicketProposal.scss';

interface TicketProposalProps {
  respondReady: boolean;
  onYes: () => void;
  onNo: () => void;
}

export function TicketProposal({ respondReady, onYes, onNo }: TicketProposalProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="support-ticket-card support-ticket-card--proposal" role="status">
      <p className="support-ticket-copy">
        {localeService.getText('ContactUs', 'TicketProposalMessage')}
      </p>
      <div className="support-ticket-actions">
        <button
          disabled={!respondReady}
          onClick={() => {
            setIsVisible(false);
            onYes();
          }}
          className="support-ticket-button support-ticket-button--primary"
        >
          {localeService.getText('ContactUs', 'TicketProposalYesButton')}
        </button>
        <button
          disabled={!respondReady}
          onClick={() => {
            setIsVisible(false);
            onNo();
          }}
          className="support-ticket-button support-ticket-button--secondary"
        >
          {localeService.getText('ContactUs', 'TicketProposalNoButton')}
        </button>
      </div>
    </div>
  );
}
